import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import axios from "axios";

export async function getContactMessages({
  page,
  limit,
}: {
  page: string | number;
  limit: string | number;
}): Promise<any> {
  try {
    const queryParams = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString() ?? (10).toString(),
    });

    const response = await axiosInstance.get(
      `${config.apiUrl}/contact?${queryParams}`
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data.message || "Error fetching orders");
    } else {
      throw new Error("An unknown error occurred");
    }
  }
}
